import { TextInput, TextInputProps } from '@mantine/core'

export default function CommentsInput({ ...props }: TextInputProps) {
  return <TextInput label="Uwagi" placeholder="Skaza itp." {...props} />
}
